/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type PlatformKillswitchesNumberGetPrescriptionSecurity = {
  sessionHeaderGramSession?: string | undefined;
};

export type PlatformKillswitchesNumberGetPrescriptionRequest = {
  organizationId: string;
  prescriptionId: string;
  /**
   * Session header
   */
  gramSession?: string | undefined;
};

/** @internal */
export type PlatformKillswitchesNumberGetPrescriptionSecurity$Outbound = {
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const PlatformKillswitchesNumberGetPrescriptionSecurity$outboundSchema:
  z.ZodMiniType<
    PlatformKillswitchesNumberGetPrescriptionSecurity$Outbound,
    PlatformKillswitchesNumberGetPrescriptionSecurity
  > = z.pipe(
    z.object({
      sessionHeaderGramSession: z.optional(z.string()),
    }),
    z.transform((v) => {
      return remap$(v, {
        sessionHeaderGramSession: "session_header_Gram-Session",
      });
    }),
  );

export function platformKillswitchesNumberGetPrescriptionSecurityToJSON(
  platformKillswitchesNumberGetPrescriptionSecurity:
    PlatformKillswitchesNumberGetPrescriptionSecurity,
): string {
  return JSON.stringify(
    PlatformKillswitchesNumberGetPrescriptionSecurity$outboundSchema.parse(
      platformKillswitchesNumberGetPrescriptionSecurity,
    ),
  );
}

/** @internal */
export type PlatformKillswitchesNumberGetPrescriptionRequest$Outbound = {
  organization_id: string;
  prescription_id: string;
  "Gram-Session"?: string | undefined;
};

/** @internal */
export const PlatformKillswitchesNumberGetPrescriptionRequest$outboundSchema:
  z.ZodMiniType<
    PlatformKillswitchesNumberGetPrescriptionRequest$Outbound,
    PlatformKillswitchesNumberGetPrescriptionRequest
  > = z.pipe(
    z.object({
      organizationId: z.string(),
      prescriptionId: z.string(),
      gramSession: z.optional(z.string()),
    }),
    z.transform((v) => {
      return remap$(v, {
        organizationId: "organization_id",
        prescriptionId: "prescription_id",
        gramSession: "Gram-Session",
      });
    }),
  );

export function platformKillswitchesNumberGetPrescriptionRequestToJSON(
  platformKillswitchesNumberGetPrescriptionRequest:
    PlatformKillswitchesNumberGetPrescriptionRequest,
): string {
  return JSON.stringify(
    PlatformKillswitchesNumberGetPrescriptionRequest$outboundSchema.parse(
      platformKillswitchesNumberGetPrescriptionRequest,
    ),
  );
}
